import React from "react";
import { mapMultiClassnames } from "utils/map-modifier";
import "./index.scss";

interface TagProps {
  modifiers?: Modifiers;
  children: string;
  color?: string;
}

const Tag: React.FC<TagProps> = ({modifiers, children, ...params}: TagProps) => {
  return (
    <span className={mapMultiClassnames("a-tag", modifiers)}
      {...((params as { color: string })?.color ? {
        style: {
          backgroundColor: params.color,
          borderColor: params.color
        }} : {})}>
      {children}
    </span>
  );
};

export default Tag;
